import { HiPlus } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { mockInstitutions } from '../mockInstitutions';
import { TablePageLayout } from '@/components/Layout/TablePageLayout';
import { Badge, Button, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui';
import { formatDateTime } from '@/utils/dateTime';

export default function Institution() {
  const navigate = useNavigate();

  return (
    <>
      <TablePageLayout
        title="기관 목록"
        description="기관 정보를 관리하고 조회하세요"
        action={
          <Button leftIcon={<HiPlus />} onClick={() => navigate('/dashboard/institutions/new')}>
            기관 추가
          </Button>
        }>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>이름</TableHead>
              <TableHead>코드</TableHead>
              <TableHead>생성일</TableHead>
              <TableHead>수정일</TableHead>
              <TableHead>상태</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {mockInstitutions.map((institution) => (
              <TableRow
                key={institution.id}
                className="cursor-pointer"
                onClick={() => navigate(`/dashboard/institutions/${institution.id}`)}>
                <TableCell>{institution.id}</TableCell>

                <TableCell>{institution.name}</TableCell>
                <TableCell>{institution.code}</TableCell>
                <TableCell>{formatDateTime(institution.createdAt)}</TableCell>
                <TableCell>{formatDateTime(institution.updatedAt)}</TableCell>
                <TableCell>
                  <Badge variant={institution.state === 'NORMAL' ? 'success' : 'danger'}>{institution.state}</Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TablePageLayout>
    </>
  );
}
